import { render, staticRenderFns } from "./Uuid.vue?vue&type=template&id=23ed0215&scoped=true"
import script from "./Uuid.vue?vue&type=script&lang=js"
export * from "./Uuid.vue?vue&type=script&lang=js"
import style0 from "./Uuid.vue?vue&type=style&index=0&id=23ed0215&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23ed0215",
  null
  
)

export default component.exports